import { Link } from "@frontend/lib/link";
import { Reveal } from "@frontend/components/site/reveal";
import { Section } from "@frontend/components/site/section";
import { StoreBadges } from "@frontend/components/site/store-badges";

export function ClosingCta({ signedIn }: { signedIn: boolean }) {
  return (
    <Section tight className="bg-[#f3f7f4]">
      <Reveal>
        <div className="mkt-closing relative overflow-hidden px-6 py-16 text-center sm:px-12 sm:py-24">
          <div className="mkt-blob mkt-blob-a opacity-70" aria-hidden="true" />
          <div className="mkt-blob mkt-blob-b opacity-60" aria-hidden="true" />

          <div className="relative mx-auto max-w-2xl">
            <p className="mkt-kicker">Get started</p>
            <h2 className="mkt-display mt-4 text-4xl leading-[1.05] text-balance sm:text-5xl lg:text-[3.5rem]">
              One link in your bio.
              <br />
              <span className="mkt-serif text-[#0a9f56]">Zero DM chaos.</span>
            </h2>
            <p className="mx-auto mt-5 max-w-md text-lg text-ink/55">
              Claim your username, share the link, and let offers arrive with terms already attached.
            </p>

            <div className="mt-9 flex justify-center">
              {signedIn ? (
                <Link href="/collabs" className="mkt-cta inline-flex items-center justify-center rounded-full px-8 py-4 text-base font-semibold">
                  Open your collabs
                </Link>
              ) : (
                <Link href="/login" className="mkt-cta inline-flex items-center justify-center rounded-full px-8 py-4 text-base font-semibold">
                  Create your collab link
                </Link>
              )}
            </div>

            <div className="mt-10 flex flex-col items-center gap-3">
              <StoreBadges className="justify-center" />
            </div>
          </div>
        </div>
      </Reveal>
    </Section>
  );
}
